import { axiosService } from '@services'

import { API } from '../endPoints'

export default async function updatePlantActive(plantId: string, isActive: boolean) {
  if (!plantId) {
    throw new Error('Plant ID is required')
  }

  return axiosService({
    method: 'post',
    apiPath: API.PLANT_DATA,
    data: { plant_id: plantId, is_active: isActive },
  })
}
